import React from 'react';
import { Input } from '@this/shared/ui/inputs/input';
import { Select } from '@this/shared/ui/inputs/select';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';
import { onlineApplicationStyles } from './styles';
import type { ValidationErrors } from './types';
import type { ValidationFieldName } from '../shared/validation';

interface BankAccountFieldsProps {
  bankName: string;
  setBankName: (value: string) => void;
  branchName: string;
  setBranchName: (value: string) => void;
  accountType: string;
  setAccountType: (value: string) => void;
  accountHolderName: string;
  setAccountHolderName: (value: string) => void;
  accountNumber: string;
  setAccountNumber: (value: string) => void;
  errors: ValidationErrors;
  touched: Record<string, boolean>;
  handleBlur: (field: ValidationFieldName) => void;
  handleFieldValidation: (field: ValidationFieldName, value: string) => ValidationErrors;
}

const accountTypeOptions = [
  { value: '1', label: '普通' },
  { value: '2', label: '当座' }
];

export const BankAccountFields: React.FC<BankAccountFieldsProps> = ({
  bankName,
  setBankName,
  branchName,
  setBranchName,
  accountType,
  setAccountType,
  accountHolderName,
  setAccountHolderName,
  accountNumber,
  setAccountNumber,
  errors,
  touched,
  handleBlur,
  handleFieldValidation
}) => {
  return (
    <>
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '32px', marginBottom: '16px' }}>返金口座</h2>
      <p style={{ fontSize: '14px', marginBottom: '16px', color: '#666' }}>
        弊社から貴社への旅行代金の返金が発生する場合がございますので、返金用口座をご入力ください
      </p>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          金融機関名 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={bankName}
          onChange={e => {
            setBankName(e.target.value);
            handleFieldValidation('bankName', e.target.value);
          }}
          onBlur={() => handleBlur('bankName')}
          placeholder="金融機関名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.bankName && errors.bankName)}
        />
        {touched.bankName && errors.bankName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.bankName}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          支店名 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={branchName}
          onChange={e => {
            setBranchName(e.target.value);
            handleFieldValidation('branchName', e.target.value);
          }}
          onBlur={() => handleBlur('branchName')}
          placeholder="支店名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.branchName && errors.branchName)}
        />
        {touched.branchName && errors.branchName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.branchName}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          口座種別 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Select
          value={accountType}
          onChange={e => {
            setAccountType(e.target.value);
            handleFieldValidation('accountType', e.target.value);
          }}
          onBlur={() => handleBlur('accountType')}
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.accountType && errors.accountType)}
        >
          <option value="">選択してください</option>
          {accountTypeOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        {touched.accountType && errors.accountType && (
          <div style={onlineApplicationStyles.formError.text}>{errors.accountType}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          口座名義（カナ） <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={accountHolderName}
          onChange={e => {
            setAccountHolderName(e.target.value);
            handleFieldValidation('accountHolderName', e.target.value);
          }}
          onBlur={() => handleBlur('accountHolderName')}
          placeholder="口座名義を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.accountHolderName && errors.accountHolderName)}
        />
        {touched.accountHolderName && errors.accountHolderName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.accountHolderName}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          口座番号 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={accountNumber}
          onChange={e => {
            setAccountNumber(e.target.value);
            handleFieldValidation('accountNumber', e.target.value);
          }}
          onBlur={() => handleBlur('accountNumber')}
          placeholder="口座番号を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.accountNumber && errors.accountNumber)}
        />
        {touched.accountNumber && errors.accountNumber && (
          <div style={onlineApplicationStyles.formError.text}>{errors.accountNumber}</div>
        )}
      </div>
    </>
  );
};
